export default __webpack_public_path__ + "static/media/onboardingAside.76f4243a.png";